<template>
    <div>
      <b-navbar toggleable="lg" type="light">
        <b-navbar-brand href="#"
          ><img class="logo" src="/assets/img/logo.png"
        /></b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto left">
            <a @click="logout()">Salir</a>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <router-view></router-view>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default{

  methods:{
    ...mapActions("auth",["logout"])
  }

}

</script>